import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { getDefaultDashboardPath, resolvePrimaryRole } from '../../utils/rolePriority';
import { Loader2 } from 'lucide-react';
import { devLog } from '../../utils/devLog';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login, user } = useContext(AuthContext);
  const [sessionChecked, setSessionChecked] = useState(Boolean(user));

  useEffect(() => {
    if (user) {
      setSessionChecked(true);
      return undefined;
    }

    let cancelled = false;

    const establishSession = async () => {
      devLog.log('AuthCallback: Establishing session from HttpOnly cookie');
      await login();
      if (!cancelled) {
        setSessionChecked(true);
      }
    };

    establishSession();

    return () => {
      cancelled = true;
    };
  }, [login, user]);

  useEffect(() => {
    if (sessionChecked && !user) {
      devLog.error('AuthCallback: No session cookie found after OAuth redirect.');
      navigate('/', { replace: true });
    }
  }, [sessionChecked, user, navigate]);

  useEffect(() => {
    if (user) {
      const timer = setTimeout(() => {
        const target = getDefaultDashboardPath(resolvePrimaryRole(user));
        navigate(target, { replace: true });
      }, 100);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [user, navigate]);

  return (
    <div className="flex min-h-[100dvh] w-full min-w-0 flex-col items-center justify-center gap-3 overflow-x-hidden px-4 pt-[var(--browser-recommendation-banner-h,0px)] sm:flex-row sm:gap-4">
      <Loader2 className="h-10 w-10 shrink-0 animate-spin text-blue-600 sm:h-12 sm:w-12" aria-hidden="true" />
      <span className="text-center text-ds-body text-slate-700 dark:text-slate-300">
        Authenticating...
      </span>
    </div>
  );
};

export default AuthCallback;
